import axios from 'axios'
import { Deposit, SmallDeposit } from 'src/core/models'

export async function getDepositsListAPI(total = 0): Promise<Deposit[]> {
  const { data } = await axios.get(`/api/v1/deposits/get?total=${total}`)
  const deposits = data?.result?.map((x: Deposit) => {
    return { ...x, key: x.id }
  })
  return deposits
}

export async function removeDepositsAPI(deposits: Deposit[]): Promise<string> {
  const payload = { depositsIds: deposits.map(d => d.id) }
  const { data } = await axios.post(`/api/v1/deposits/remove_deposits/`, payload)
  return data
}

export async function fetchDepositAPI(id: number): Promise<SmallDeposit> {
  const { data } = await axios.get(`/api/v1/deposits/${id}/`)
  return data
}

export async function validateDepositAPI(id: number): Promise<string> {
  const url = `/api/v1/adminmanager/validate_deposit/?id=${id}`
  const { data } = await axios.post(url)
  return data
}

export async function cancelDepositAPI(id: number): Promise<string> {
  const url = '/api/v1/deposits/remove_deposits_superuser/'
  const { data } = await axios.post(url, { depositsIds: [id] })
  return data
}
